export const SOURCE_VISUALS = {
    PENDING_AAI: {
        key: "PENDING_AAI",
        label: "当前待审",
        shortLabel: "待审",
        hint: "当前批次可处理对象",
        tone: "pending",
    },
    COMMITTED_INVOICE: {
        key: "COMMITTED_INVOICE",
        label: "已入库参照",
        shortLabel: "已入库",
        hint: "正式入库后的稳定参照",
        tone: "committed",
    },
};

export const SOURCE_DISPLAY_ORDER = {
    PENDING_AAI: 0,
    COMMITTED_INVOICE: 1,
};

export function getSourceVisual(sourceType) {
    return SOURCE_VISUALS[sourceType] || {
        key: sourceType || "UNKNOWN",
        label: sourceType || "未知来源",
        shortLabel: sourceType || "未知",
        hint: "未识别来源",
        tone: "neutral",
    };
}

export function getSourceToneClass(sourceType) {
    return `source-tone--${getSourceVisual(sourceType).tone}`;
}

export function sortBySourceDisplayOrder(items, getType) {
    return [...items].sort((a, b) => {
        return compareSourceDisplayOrder(getType(a), getType(b));
    });
}

export function compareSourceDisplayOrder(leftType, rightType) {
    return (SOURCE_DISPLAY_ORDER[leftType] ?? 99) - (SOURCE_DISPLAY_ORDER[rightType] ?? 99);
}
